export const account_home_company_profile = {
  company_profile: "Company Profile",
  company_profile_blurb:
    "How your organization appears across the PAX marketplace — contact details, logo, and the public-facing about copy.",
} as const;
